import $ from "jquery";
import "magnific-popup";
import Swiper from "swiper/swiper-bundle";

export default function openGalleriesModal() {
  var mySwiper = undefined;

  function getActiveTopic() {
    const selectedSlide = $(".swiper-slide-active").attr("data-gallery");

    const selectedMenuItems = document.querySelectorAll(
      `[data-trigger='${selectedSlide}']`
    );

    const menuItems = document.querySelectorAll(".modal-menu");

    menuItems.forEach((item) => {
      if (item.classList.contains("active")) {
        item.classList.remove("active");
      }
    });

    selectedMenuItems.forEach((e) => {
      e.classList.add("active");
    });
  }

  function initModal() {
    function initSwiper() {
      mySwiper = new Swiper(".galleries-slider", {
        loop: false,
        autoplay: false,
        autoHeight: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        slidesPerView: 1,
        slidesPerGroup: 1,
        keyboard: {
          enabled: true,
        },
        navigation: {
          nextEl: ".galleries-slider-next",
          prevEl: ".galleries-slider-prev",
        },
        pagination: {
          el: ".swiper-pagination--galleries",
          type: "fraction",
        },
      });

      mySwiper.on("slideChangeTransitionEnd", function () {
        getActiveTopic();
      });
    }

    $(".js-open-galleries-modal").magnificPopup({
      type: "inline",
      midClick: true,
      callbacks: {
        open: function () {
          initSwiper();

          const slideNumber = $(this.st.el).data("slide");

          function goToPage(numberPage) {
            mySwiper.slideTo(numberPage, 100, false);
          }

          goToPage(slideNumber);
          setTimeout(function () {
            mySwiper.update();
          }, 500);

          getActiveTopic();

          const innerGalleryMenu = document.querySelectorAll(".modal-menu");

          innerGalleryMenu.forEach((item) => {
            item.addEventListener("click", function () {
              const name = item.getAttribute("data-trigger");

              const firstCatSlide = document.querySelector(
                `[data-gallery='${name}']`
              );

              const firstSlideNumber = firstCatSlide.getAttribute(
                "data-slidenumber"
              );

              goToPage(firstSlideNumber);

              setTimeout(function () {
                mySwiper.update();
              }, 500);

              getActiveTopic();
            });
          });
        },
        close: function () {
          $(".galleries-slider").each(function () {
            mySwiper.destroy();
          });
        },
      },
    });
  }

  const isPresent = document.getElementsByClassName("galleries-modal");

  if (isPresent.length > 0) {
    $(document).ready(() => {
      initModal();
    });
  }
}
